import Tooltip from "@material-ui/core/Tooltip";
import React from "react";

// TooltipWrapper gets initial MyTooltip props without Tooltip props
// and passes them to children (an input component in this example)
const TooltipWrapper = React.forwardRef(
  ({ children, ...props }: any, ref: any) => (
    <div {...props} ref={ref}>
      {children}
    </div>
  )
);

// CustomTooltip gets explicit props and props added by SimpleForm
// and passes them together to the Tooltip.
const CustomTooltip = ({ children, ...props }: any) => (
  <Tooltip {...props}>
    <TooltipWrapper>{children}</TooltipWrapper>
  </Tooltip>
);

export default CustomTooltip;
